import { Link } from "react-router-dom";
import styled from "styled-components";

import { ContainerComponent } from "../../ui";

export const Wrapper = styled("header")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  position: "sticky",
  left: 0,
  top: 0,
  width: "100%",
  backgroundColor: theme.palette.header.background,
  color: theme.palette.header.text,
  height: 72,
  zIndex: 152,
  boxShadow: `0 2px 20px ${theme.palette.header.shadow}`,
  backdropFilter: "blur(10px)",
  borderBottom: `1px solid ${theme.palette.header.border}`,
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
}));

export const StyledContainer = styled(ContainerComponent)(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  flexGrow: 1,
  gap: "24px",

  [theme.down("lg")]: {
    gap: "16px",
  },
}));

export const LeftSection = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",
  flexShrink: 0,
}));

export const NavTabs = styled("nav")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",

  [theme.down("md")]: {
    display: "none",
  },
}));

export const NavIcon = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  transition: "all 0.25s ease",
}));

export const NavText = styled("span")(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 500,
  letterSpacing: "0.01em",
  transition: "all 0.25s ease",
  whiteSpace: "nowrap",

  [theme.down("lg")]: {
    display: "none",
  },
}));

export const NavTab = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 16px",
  borderRadius: "10px",
  color: theme.palette.header.textMuted,
  textDecoration: "none",
  transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden",

  "&:hover": {
    color: theme.palette.header.text,
    backgroundColor: theme.palette.header.hoverBg,

    [`${NavIcon}`]: {
      transform: "scale(1.1)",
      color: theme.palette.header.primary,
    },
  },

  "&.active": {
    color: theme.palette.white,
    background: `linear-gradient(135deg, ${theme.palette.header.primary} 0%, ${theme.palette.header.primaryDark} 100%)`,
    boxShadow: `0 4px 14px ${theme.palette.header.primaryShadow}`,

    [`${NavIcon}`]: {
      color: theme.palette.white,
    },

    [`${NavText}`]: {
      color: theme.palette.white,
    },

    "&:hover": {
      boxShadow: `0 6px 20px ${theme.palette.header.primaryShadowHover}`,
      transform: "translateY(-1px)",
    },
  },

  [theme.down("lg")]: {
    padding: "10px 12px",
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: theme.palette.header.textMuted,
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: 500,
  padding: "8px 12px",
  borderRadius: "8px",
  transition: "all 0.2s ease",

  "&:hover": {
    color: theme.palette.header.text,
    backgroundColor: theme.palette.header.hoverBg,
  },
}));

